exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-de9c3f6e]:disabled {\n  opacity: 0.5;\n}", ""]);

// exports
